module.exports = __webpack_public_path__ + "img/banner2.f3e4b38a.png";